import { useEffect, useRef, useState } from 'react';
import { getContactMapStatus } from './getContactMapStatus';
export function useContactMapStatus(anchorContact, accounting, accountingCustomers) {
    const [mapStatus, setMapStatus] = useState(getContactMapStatus(anchorContact, accounting, accountingCustomers));
    const isMappingInProgress = useRef(false);
    useEffect(()=>{
        if (!isMappingInProgress.current) {
            setMapStatus(getContactMapStatus(anchorContact, accounting, accountingCustomers));
        }
    }, [
        anchorContact,
        accounting,
        accountingCustomers
    ]);
    const startMapping = ()=>{
        isMappingInProgress.current = true;
        setMapStatus('mapping');
    };
    const finishMappingSuccess = (status)=>{
        isMappingInProgress.current = false;
        setMapStatus(status);
    };
    const finishMappingFailure = ()=>{
        isMappingInProgress.current = false;
        setMapStatus('failedToMap');
    };
    return {
        mapStatus,
        startMapping,
        finishMappingSuccess,
        finishMappingFailure
    };
}
